export default __webpack_public_path__ + "424fc076fbe42cb34ef52c4513fcda36.svg";